import {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
  useRef,
} from "react";
import CommonModal from "views/components/CommonModal";
import { checkDevice, getInfoList } from "../digital-human/CheckTools";
import { Toast } from "react-vant";
import DSBridge from "dsbridge";
import styles from "./CheckModal.module.less";
const successCancelImg = require("@/images/modal/success-cancel.png");
const failCancelImg = require("@/images/modal/fail-cancel.png");
const CheckModal = forwardRef(({}, ref) => {
  const [modalShow, setModalShow] = useState(null);
  const [activeTeacher, setActiveTeacher] = useState(null);
  const downloadTimer = useRef(null);
  const startAudioRef = useRef(null);
  const clearDownloadTimer = () => {
    if (downloadTimer.current) {
      clearInterval(downloadTimer.current);
      downloadTimer.current = null;
    }
  };
  const handleCloseModal = () => {
    if (activeTeacher) {
      DSBridge.call("duix.cancelDownload", {
        teacherId: activeTeacher.teacherId,
      });
      setActiveTeacher(null);
    }
    clearDownloadTimer();
    startAudioRef.current = null;
    setModalShow(null);
  };
  const handleDownload = (character_id, startVideo) => {
    setModalShow({
      result: true,
      message: "正在加载，请保持APP在前台运行，屏幕常亮，耐心等待3-5分钟哦～",
    });
    DSBridge.call("duix.startDownload", {
      teacherId: character_id,
    });
    clearDownloadTimer();
    downloadTimer.current = setInterval(() => {
      const nativeValue = getInfoList();
      if (Array.isArray(nativeValue)) {
        const findItem = nativeValue.find(
          (item) => item.teacherId === character_id
        );
        setActiveTeacher(findItem);
        if (findItem.state === "STATE_UNZIP_COMPLETED") {
          handleCloseModal();
          startVideo();
        }
        if (
          findItem.state === "STATE_DOWNLOAD_ERROR" ||
          findItem.state === "STATE_UNZIP_ERROR"
        ) {
          clearDownloadTimer();
          setModalShow({
            result: false,
            message: findItem.desc,
          });
        }
      } else {
        clearDownloadTimer();
        return setModalShow(nativeValue);
      }
    }, 3000);
  };
  const handleClickVideo = (character_id, startVideo, startAudio) => {
    startAudioRef.current = startAudio;
    const deviceState = checkDevice();
    if (deviceState !== true) {
      return setModalShow(deviceState);
    }
    const nativeValue = getInfoList();
    if (!Array.isArray(nativeValue)) {
      return setModalShow(nativeValue);
    }
    if (!!!character_id) {
      return Toast.info("无当前外教信息，请重试");
    }
    const findItem = nativeValue.find(
      (item) => item.teacherId === character_id
    );
    if (findItem) {
      if (findItem.state === "STATE_UNZIP_COMPLETED") {
        return startVideo();
      } else if (findItem.desc === "未配置模型") {
        return Toast.info("未配置模型，请选择其他外教");
      } else {
        return handleDownload(character_id, startVideo);
      }
    } else {
      return Toast.info("无当前外教模型，请重试");
    }
  };
  useImperativeHandle(ref, () => ({
    handleClickVideo,
  }));
  useEffect(() => {
    return () => {
      clearDownloadTimer();
    };
  }, []);
  return (
    <CommonModal isOpen={!!modalShow}>
      {!!modalShow ? (
        <div className={styles["teacher-list-pop"]}>
          <div className={styles["pop-back"]}>
            <div className={styles["pop-back-title"]}>{"温馨提示"}</div>
            <div className={styles["pop-back-content"]}>
              {modalShow.message}
            </div>
            {Boolean(modalShow.result) === true ? (
              <>
                <div className={styles["pop-back-progress"]}>
                  <div
                    style={{
                      width: `${activeTeacher?.progress || 0}%`,
                    }}
                    className={styles["pop-back-progress-percentage"]}
                  ></div>
                </div>
                <img
                  className={styles["pop-back-button"]}
                  src={successCancelImg}
                  onClick={() => {
                    if (startAudioRef.current) {
                      startAudioRef.current();
                    }
                    handleCloseModal();
                  }}
                />
              </>
            ) : (
              <img
                className={styles["pop-back-button"]}
                src={failCancelImg}
                onClick={() => {
                  if (startAudioRef.current) {
                    startAudioRef.current();
                  }
                  handleCloseModal();
                }}
              />
            )}
          </div>
          <img
            onClick={handleCloseModal}
            className={styles["close-icon"]}
            src={require("@/images/mine/recommend-officer/button_cancel.png")}
          />
        </div>
      ) : null}
    </CommonModal>
  );
});
export default CheckModal;
